import React, { Component } from 'react'
import { block } from 'bem-cn'
import CalendarSwitcherContainer from '../../Containers/CalendarSwitcherContainer'
import { withI18n } from "react-i18next";
const b = block('CalendarSidebar')

class Sidebar extends Component {
    render() {
        const { calendars, t } = this.props

        return (
            <div className={b()}>
                <h3 className={b('title')}>{t('calendar:Calendars')}</h3>

                {calendars.map(calendar => (
                    <CalendarSwitcherContainer key={calendar.id} {...calendar} />
                ))}
            </div>
        )
    }
}

export default withI18n()(Sidebar)